import useSWR from "swr";
import { api } from "@dreambigger/shared/src/api/acquire";
import useFetcher from "./use-fetcher";
import { FinancialInstitution } from "@dreambigger/shared/src/types";

type UseOrganizationOptions = {
  enabled?: boolean;
};

export default function useOrganization(
  organizationSlug?: string,
  options?: UseOrganizationOptions
) {
  const { fetcher } = useFetcher(api);
  const { enabled = true } = options || {};

  const shouldFetch = enabled && organizationSlug;

  const { data, error, isValidating } = useSWR<FinancialInstitution>(
    shouldFetch
      ? `/organizations/${organizationSlug}/financial-institution`
      : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    financialInstitution: data,
    isLoading: !error && !data && isValidating,
    error,
  };
}
